d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Přehled rozespořených produktů</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4 md3 lg2>
                <clientsearch label="Klient" v-model="klient" class="mx-2"></clientsearch>
              </v-flex>
              <v-flex xs12 sm4 md3 lg2>
                <productsearch label="Cílový produkt" v-model="cilovy_produkt" class="mx-2"></productsearch>
              </v-flex>
              <v-flex xs12 sm4 md3 lg2>
                <v-select :items="procentoItems" v-model="min_procento" label="Min. procento rozespoření" class="mx-2" clearable>
                  <template slot="item" slot-scope="props">{{props.item}} %</template>
                  <template slot="selection" slot-scope="props">{{props.item}} %</template>
                </v-select>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loadingTable"
              :pagination.sync="pagination"
              :total-items="pagination.totalItems"
              :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>{{ props.item.nazev_sporeni }}</td>
                  <td>
                    <router-link :to="{ path: '/sporici-produkty/' + props.item.sporici_produkt.id }" target="_blank">
                      {{ props.item.sporici_produkt.sporici_program }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank">
                      {{ props.item.cilovy_produkt.nazev }}
                    </router-link>
                  </td>
                  <td class="text-xs-right">{{ props.item.aktualni_pocet_g | formatMoney }} g</td>
                  <td class="text-xs-right">{{ props.item.procento | formatMoney }} %</td>
                </template>
              </v-data-table>
            </div>
            <v-layout row wrap class="mt-5">
              <v-flex xs12>
                <h3>Přehled seskupený dle cílových produktů</h3>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1 mt-2 mb-5">
              <v-data-table
              :headers="produktyHeaders"
              :items="produkty"
              :loading="loadingTable"
              hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.id }" target="_blank">
                      {{ props.item.cilovy_produkt }}
                    </router-link>
                  </td>
                  <td class="text-xs-right">{{ props.item.aktualni_pocet_g | formatMoney }} g</td>
                  <td class="text-xs-right">{{ props.item.ks | formatMoney }} ks</td>
                  <td class="text-xs-right">{{ props.item.procento | formatMoney }} %</td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Klient', value: 'osoba' },
        { text: 'Název spoření', value: 'nazev_sporeni' },
        { text: 'Spořící program', value: 'sporici_produkt' },
        { text: 'Cílový produkt', value: 'cilovy_produkt' },
        { text: 'Rozespořené množství', value: 'aktualni_pocet_g', align: 'right' },
        { text: 'Rozespořené množství (%)', value: 'procento', align: 'right' },
      ],
      produktyHeaders: [
        { text: 'Cílový produkt', value: 'osoba' },
        { text: 'Rozespořené množství', value: 'aktualni_pocet_g', align: 'right' },
        { text: 'Rozespořené množství (ks)', value: 'ks', align: 'right' },
        { text: 'Rozespořené množství (%)', value: 'procento', align: 'right' },
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "procento",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      klient: null,
      cilovy_produkt: null,
      procentoItems: [ 25, 50, 75, 90 ] ,
      min_procento: null,
      produkty: []
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    klient () {
      this.load();
    },
    cilovy_produkt () {
      this.load();
    },
    min_procento () {
      this.load();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    }
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/rozesporene-produkty/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        klient: this.klient,
        cilovy_produkt: this.cilovy_produkt,
        min_procento: this.min_procento
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.produkty = body.produkty;
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/RozesporeneProdukty.vue